import React from 'react'
import { Button } from '@grammarly/badger-ui'
import { Tooltip, TooltipContent, TooltipContextProps, TooltipTrigger } from '@grammarly/design-system'
import cn from 'classnames'
import styles from './icon-button.module.scss'

interface IconButtonProps extends React.ComponentProps<typeof Button> {
  icon?: React.ReactElement
  tooltip?: {
    content: React.ReactNode
    lightTheme?: boolean
  } & TooltipContextProps
  'aria-label': string
  'aria-controls'?: string
}

export const IconButton: React.FC<IconButtonProps> = ({ icon, tooltip, children, ...props }) => {
  const iconElement = icon || children
  const iconToRender = React.isValidElement(iconElement)
    ? React.cloneElement(iconElement as React.ReactHTMLElement<HTMLImageElement>, {
        'aria-hidden': true,
        focusable: false,
      })
    : null

  if (!tooltip) {
    return (
      <Button padding="none" {...props}>
        {iconToRender}
      </Button>
    )
  }

  const { content, ...rest } = tooltip

  return (
    <Tooltip {...rest}>
      <TooltipTrigger asChild ref={undefined}>
        <span>
          <Button padding="none" {...props}>
            {iconToRender}
          </Button>
        </span>
      </TooltipTrigger>
      <TooltipContent
        root={null}
        ref={undefined}
        className={cn({
          [styles.lightTheme]: tooltip.lightTheme,
        })}
      >
        {content}
      </TooltipContent>
    </Tooltip>
  )
}
